import { render, staticRenderFns } from "./ModalSupport.vue?vue&type=template&id=53a19982&"
import script from "./ModalSupport.vue?vue&type=script&lang=js&"
export * from "./ModalSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports